import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';
import VueScrollTo from 'vue-scrollto';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { loadLanguage } from '@/core/i18nUtils';
import createRouter from './router';

export default (i18n) => {
  Vue.use(VueScrollTo);

  Vue.use(VueGoogleMaps, {
    load: {
      key: process.env.GOOGLE_MAP_API_KEY,
      v: '3',
    },
  });

  AOS.init();

  const RecuritmentPost = () => import('./main');

  const vue = new Vue({
    el: '#recruitment-post',
    i18n,
    router: createRouter(),
    data() {
      return {
        loadedI18n: false,
      };
    },
    render(h) {
      if (this.loadedI18n) {
        return h(RecuritmentPost);
      }
      return h('p', '');
    },
    async beforeCreate() {
      await loadLanguage(this, [
        'main',
        'find',
        'stock_info',
        'building_page',
        'transaction',
        'details',
      ]);

      switch (window.lang) {
        case 'english': this.$i18n.locale = 'en'; break;
        case 'gb': this.$i18n.locale = 'gb'; break;
        default: this.$i18n.locale = 'zh';
      }
      this.loadedI18n = true;
    },
  });

  return vue;
};
